// extracted by mini-css-extract-plugin
module.exports = {"imagesWrapper":"Dm-z"};